/**
 * Legacy Places Autocomplete: address_components[]
 */
function getLegacy(components, type) {
  if (!Array.isArray(components)) return "";
  const c = components.find((x) => x.types && x.types.includes(type));
  return c ? c.long_name : "";
}

/**
 * New Places API / Place: addressComponents with longText, shortText
 */
function getNew(components, type, useShort) {
  if (!Array.isArray(components)) return "";
  const c = components.find((x) => x.types && x.types.includes(type));
  if (!c) return "";
  if (useShort) {
    return c.shortText || c.short_name || c.longText || c.long_name || "";
  }
  return c.longText || c.long_name || "";
}

/**
 * @param {object[]|undefined} addressComponents - legacy or new shape
 * @param {{ legacy?: boolean }} [opts]
 */
export function parseAddressComponentsFromGoogle(addressComponents, opts = {}) {
  const isLegacy = opts.legacy ?? Boolean(addressComponents && addressComponents[0]?.long_name);
  if (!addressComponents || !addressComponents.length) {
    return { street: "", city: "", state: "", zip: "" };
  }

  if (isLegacy) {
    const number = getLegacy(addressComponents, "street_number");
    const route = getLegacy(addressComponents, "route");
    const poBox = getLegacy(addressComponents, "subpremise");
    const street = [poBox, number, route].filter(Boolean).join(" ").trim();
    return {
      street: street,
      city:
        getLegacy(addressComponents, "locality") ||
        getLegacy(addressComponents, "sublocality") ||
        getLegacy(addressComponents, "neighborhood") ||
        "",
      state: getLegacy(addressComponents, "administrative_area_level_1") || "",
      zip: getLegacy(addressComponents, "postal_code") || "",
    };
  }

  const number = getNew(addressComponents, "street_number", false);
  const route = getNew(addressComponents, "route", false);
  const poBox = getNew(addressComponents, "subpremise", false);
  const street = [poBox, number, route].filter(Boolean).join(" ").trim();
  return {
    street: street,
    city:
      getNew(addressComponents, "locality", false) ||
      getNew(addressComponents, "sublocality", false) ||
      getNew(addressComponents, "neighborhood", false) ||
      "",
    state: getNew(addressComponents, "administrative_area_level_1", true) || "",
    zip: getNew(addressComponents, "postal_code", false) || "",
  };
}

/**
 * @param {google.maps.places.PlaceResult} place - legacy Autocomplete result
 */
export function parseFromLegacyPlaceResult(place) {
  const formatted = place?.formatted_address || "";
  if (!place?.address_components) {
    return {
      rawAddress: formatted,
      street: "",
      city: "",
      state: "",
      zip: "",
    };
  }
  const parts = parseAddressComponentsFromGoogle(place.address_components, { legacy: true });
  return {
    rawAddress: formatted,
    address: parts.street,
    ...parts,
  };
}

/** @param {object} place - new web Place */
export function parseFromNewPlace(place) {
  const formatted = place?.formattedAddress || place?.formatted_address || "";
  const comps = place?.addressComponents || place?.address_components;
  if (!comps) {
    return {
      rawAddress: formatted,
      street: "",
      city: "",
      state: "",
      zip: "",
    };
  }
  const parts = parseAddressComponentsFromGoogle(comps, {
    legacy: Boolean(comps[0]?.long_name),
  });
  return {
    rawAddress: formatted,
    address: parts.street,
    ...parts,
  };
}
